import { render, staticRenderFns } from "./text-input-label.vue?vue&type=template&id=0eeb786f&"
import script from "./text-input-label.vue?vue&type=script&lang=ts&"
export * from "./text-input-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports